import React, { useMemo } from 'react';
import { ServiceFeeToggle } from '@ftdr/service-fee-toggle-sales-library';
import { Text } from '@ftdr/blueprint-components-react';
import '@ftdr/service-fee-toggle-sales-library/dist/assets/css/_service-fee-toggle.css';
import { Brand } from '@constants/brands';
import { getBrand } from '@helpers/brand.utils';

interface TradeServiceFeeProps {
  onChange?: (e: number) => void;
  selectedFee?: string;
  serviceFees: string[];
}

const TradeServiceFee = ({ onChange, selectedFee, serviceFees }: TradeServiceFeeProps) => {
  const getTradeServiceFeeTitle = () =>
    getBrand() === Brand.HBW210 ? 'Adjust Service Fee' : 'Adjust Trade Service Call Fee';

  const key = useMemo(
    () => `service-fee-${selectedFee}-[${serviceFees.join(',')}]`,
    [selectedFee, serviceFees],
  );

  return (
    <div className={`tsfMain-${getBrand()}`} id="serviceFeeToggle">
      <ServiceFeeToggle
        key={key}
        title={getTradeServiceFeeTitle()}
        description="This is what you pay for each service request. "
        showPopOverLink
        popOverText={
          <>
            <Text className="max-w-xs" color="black" variant="caption">
              This is what you’ll pay per trade (plumbing, electrical, etc.) for a professional to
              diagnose your problem, then fix or replace it.
            </Text>

            <Text className="max-w-xs" color="black" variant="caption">
              Choose a higher fee to lower your premium payment, or choose a lower fee to pay less
              when you request service.
            </Text>

            <br></br>
            <Text className="max-w-xs" color="black" variant="caption">
              Plus sales tax, where applicable.
            </Text>
          </>
        }
        linkText="Learn more"
        currentServiceFee={selectedFee}
        serviceFees={serviceFees}
        tsfSelectionCallback={(i) => onChange(i)}
      />
    </div>
  );
};

export default TradeServiceFee;
